<template>
  <div class="container">
    <div class="box">
      <div class="list_select">
        <div class="select_container">
          <vue-scroll>
            <div class="select_box">
              <p>
                {{ $store.state.videoTitle }}
              </p>
              <div class="station_select">
                <p
                  @click="changeStation(item, index)"
                  :title="item.name"
                  v-for="(item, index) in stationsItem"
                  :class="{ station_act: item.check }"
                >
                  {{ item.stnm }}
                </p>
              </div>
            </div>
          </vue-scroll>
        </div>
      </div>

      <div class="message">
        <div class="header">
          <div @click="editRecipient()" style="margin-left:10px" class="info_btn query_btns">
            接收人
          </div>
        </div>
        <div class="list_container">
          <div class="list list_title">
            <div>元素名称</div>
            <div>单位</div>
            <div>阈值范围</div>
            <div>最小值</div>
            <div>最大值</div>
            <div>单位</div>
            <div>所属要素</div>
            <div>操作</div>
          </div>
          <div class="list_box">
            <vue-scroll>
              <div class="list_data">
                <div class="list" v-for="(item, index) in listData">
                  <div :title="item.monName">{{ item.monName }}</div>
                  <div :title="item.unit">{{ item.unit }}</div>
                  <div :title="item.yzTypename">{{ item.yzTypename }}</div>
                  <div :title="item.yzMin">{{ item.yzMin }}</div>
                  <div :title="item.yzMax">{{ item.yzMax }}</div>
                  <div :title="item.eleName">{{ item.eleName }}</div>
                  <div>
                    <div
                      @click="saveDialogitem(item)"
                      class="edit_btn query_btns"
                    >
                      编辑
                    </div>
                  </div>
                </div>
              </div>
            </vue-scroll>
          </div>
        </div>
      </div>
      <transition name="el-fade-in-linear">
        <div v-if="needHide" class="hide">
          <div class="hide_container">
            <div class="hide_box">
              <div class="hide_module">
                <div>
                  <span>手机号1: </span>
                  <el-input
                    @blur="blurHander(1, $event, '手机号1')"
                    v-model="hide.tel1"
                    clearable
                    oninput="value=value.replace(/[^\d]/g, '')"
                  ></el-input>
                </div>
                <div>
                  <span>邮箱1: </span>
                  <el-input
                    @blur="blurHander(2, $event, '邮箱1')"
                    v-model="hide.mail1"
                    clearable
                  ></el-input>
                </div>
                <div>
                  <span>备注1: </span>
                  <el-input v-model="hide.remarks1" clearable></el-input>
                </div>
              </div>
              <div class="hide_module">
                <div>
                  <span>手机号2: </span>
                  <el-input
                    @blur="blurHander(1, $event, '手机号2')"
                    v-model="hide.tel2"
                    clearable
                    oninput="value=value.replace(/[^\d]/g, '')"
                  ></el-input>
                </div>
                <div>
                  <span>邮箱2: </span>
                  <el-input
                    @blur="blurHander(2, $event, '邮箱2')"
                    v-model="hide.mail2"
                    clearable
                  ></el-input>
                </div>
                <div>
                  <span>备注2: </span>
                  <el-input v-model="hide.remarks2" clearable></el-input>
                </div>
              </div>
              <div class="hide_module">
                <div>
                  <span>手机号3: </span>
                  <el-input
                    @blur="blurHander(1, $event, '手机号3')"
                    v-model="hide.tel3"
                    clearable
                    oninput="value=value.replace(/[^\d]/g, '')"
                  ></el-input>
                </div>
                <div>
                  <span>邮箱3: </span>
                  <el-input
                    @blur="blurHander(2, $event, '邮箱3')"
                    v-model="hide.mail3"
                    clearable
                  ></el-input>
                </div>
                <div>
                  <span>备注3: </span>
                  <el-input v-model="hide.remarks3" clearable></el-input>
                </div>
              </div>
              <div class="hide_module">
                <div>
                  <span>手机号4: </span>
                  <el-input
                    @blur="blurHander(1, $event, '手机号4')"
                    v-model="hide.tel4"
                    clearable
                    oninput="value=value.replace(/[^\d]/g, '')"
                  ></el-input>
                </div>
                <div>
                  <span>邮箱4: </span>
                  <el-input
                    @blur="blurHander(2, $event, '邮箱4')"
                    v-model="hide.mail4"
                    clearable
                  ></el-input>
                </div>
                <div>
                  <span>备注4: </span>
                  <el-input v-model="hide.remarks4" clearable></el-input>
                </div>
              </div>
              <div class="hide_module">
                <div>
                  <span>手机号5: </span>
                  <el-input
                    @blur="blurHander(1, $event, '手机号5')"
                    v-model="hide.tel5"
                    clearable
                    oninput="value=value.replace(/[^\d]/g, '')"
                  ></el-input>
                </div>
                <div>
                  <span>邮箱5: </span>
                  <el-input
                    @blur="blurHander(2, $event, '邮箱5')"
                    v-model="hide.mail5"
                    clearable
                  ></el-input>
                </div>
                <div>
                  <span>备注5: </span>
                  <el-input v-model="hide.remarks5" clearable></el-input>
                </div>
              </div>
              <div class="hide_btns">
                <div @click="saveHander(2)" class="save_btn query_btns">
                  保存
                </div>
                <div @click="closeHander()" class="close_btn query_btns">
                  关闭
                </div>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </div>
    <el-dialog
      title="接收人信息"
      :visible.sync="dialogVisible"
      top="30vh"
      width="65%"
      :modal-append-to-body="false"
    >
      <el-form :inline="true" class="demo-form-inline">
        <div v-for="(item, index) in recipientData">
          <el-form-item style="width:calc(25% - 40px)">
            <el-input
              v-model="item.realName"
              placeholder="请输入姓名"
            ></el-input>
          </el-form-item>
          <el-form-item style="width:calc(25% - 40px)">
            <el-input
              v-model="item.phone"
              placeholder="请输入手机号"
            ></el-input>
          </el-form-item>
          <el-form-item style="width:calc(25% - 40px)">
            <el-input v-model="item.email" placeholder="请输入邮箱"></el-input>
          </el-form-item>
          <el-form-item style="width:calc(25% - 40px)">
            <el-input v-model="item.remark" placeholder="请输入备注"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="delDialog(index)">删除</el-button>
          </el-form-item>
        </div>
        <div class="btn-box">
          <el-button
            type="primary"
            icon="el-icon-circle-plus-outline"
            @click="addRecipient"
            >添加</el-button
          >
        </div>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="saveRecipient">确 定</el-button>
        <el-button @click="dialogVisible = false">取 消</el-button>
      </span>
    </el-dialog>

    <el-dialog
      title="设置阈值范围"
      :visible.sync="dialogVisible1"
      top="30vh"
      width="600px"
      :modal-append-to-body="false"
    >
      <div class="perLin ">
        <div>
          <span>阈值区间：</span>
          <el-select v-model="yzType" placeholder="请选择" style="width:400px">
            <el-option key="1" label="区间范围内" value="0"></el-option>
            <el-option key="0" label="区间范围外" value="1"></el-option>
            <el-option key="3" label="无" value="2"></el-option>
          </el-select>
        </div>
      </div>
      <div class="perLin">
        <div>
          <span style="margin-left:16px">最小值：</span>
          <el-input
            placeholder="请输入最小值"
            style="width:400px"
            v-model="yzMin"
          ></el-input>
        </div>
      </div>
      <div class="perLin">
        <div>
          <span style="margin-left:18px">最大值：</span>
          <el-input
            placeholder="请输入最大值"
            style="width:400px"
            v-model="yzMax"
          ></el-input>
        </div>
      </div>
      <span
        slot="footer"
        class="dialog-footer"
        style="display:block;width:200px;margin:0 auto;"
      >
        <el-button type="primary" @click="saveDialog">确 定</el-button>
        <el-button @click="dialogVisible1 = false">取 消</el-button>
      </span>
    </el-dialog>
  
  </div>
</template>

<script>
import $ from "jquery";
export default {
  data() {
    return {
      dialogVisible1:false,
      yzType: "",
      yzMin: "",
      yzMax: "",
      stationsItem: [],
      recipientData: [],
      listData: [],
      dialogVisible: false,
      nowStcd: "",
      value: "",
      id: "",
      hide: {
        tel1: "",
        tel2: "",
        tel3: "",
        tel4: "",
        tel5: "",
        mail1: "",
        mail2: "",
        mail3: "",
        mail4: "",
        mail5: "",
        remarks1: "",
        remarks2: "",
        remarks3: "",
        remarks4: "",
        remarks5: ""
      },
      needHide: false,
      phoneReg: /^1\d{10}$/,
      emaieReg: /\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*/
    };
  },
  components: {},
  methods: {
    // 切换站点
    changeStation(item, index) {
      for (let i of this.stationsItem) {
        i.check = false;
      }
      item.check = true;
      this.nowStcd = item.stcd;
      this.getData(item.stcd);
    },
    // 验证内容
    blurHander(type, event, title) {
      let flag;
      let e = event.target;
      if (e.value === "") {
        return;
      }
      if (type === 1) {
        if (this.phoneReg.test(e.value - 0)) {
          flag = true;
        } else {
          flag = false;
        }
      } else if (type === 2) {
        if (this.emaieReg.test(e.value)) {
          flag = true;
        } else {
          flag = false;
        }
      }
      if (flag) {
        e.style.borderColor = "#DCDFE6";
      } else {
        e.style.borderColor = "red";
        this.$message({
          message: "请确认" + title + "是否正确!",
          type: "warning"
        });
      }
    },
      delDialog(index){
                if(this.recipientData.length > 1){
                    this.recipientData.splice(index,1)
                }else{
                    this.$message({
                      message: '至少存在一条数据！',
                      type: 'warning'
                    });
                }
            },
    // 保存
    saveHander(type, item) {
      if (type === 1) {
        if (/^[-\\+]?([0-9]+\.?)?[0-9]+$/.test(item.yz - 0)) {
          let yz;
          item.yz === "" ? (yz = item.yz) : (yz = item.yz - 0);
          this.axios
            .get(
              this.$store.state.Url4 +
                "monitoringElements/updateEleInfoByEleId?yz=" +
                yz +
                "&id=" +
                item.eleId
            )
            .then(data => {
              if (data.data.success) {
                this.$message({
                  message: data.data.message,
                  type: "success"
                });
                this.getData(this.nowStcd);
              }
            })
            .catch(err => {
              console.log(err);
            });
        }
      } else if (type === 2) {
        let emailStr = "",
          phoneStr = "",
          remarkStr = "",
          // idStr = "2,9,10,11,12",
          pReg = this.phoneReg,
          eReg = this.emaieReg;
        let flag = false;
        if (this.hide.tel1.length) {
          if (!pReg.test(this.hide.tel1 - 0)) {
            flag = true;
          }
        }
        if (this.hide.mail1.length) {
          if (!eReg.test(this.hide.mail1)) {
            flag = true;
          }
        }
        if (this.hide.tel2.length) {
          if (!pReg.test(this.hide.tel2 - 0)) {
            flag = true;
          }
        }
        if (this.hide.mail2.length) {
          if (!eReg.test(this.hide.mail2)) {
            flag = true;
          }
        }
        if (this.hide.tel3.length) {
          if (!pReg.test(this.hide.tel3 - 0)) {
            flag = true;
          }
        }
        if (this.hide.mail3.length) {
          if (!eReg.test(this.hide.mail3)) {
            flag = true;
          }
        }
        if (this.hide.tel4.length) {
          if (!pReg.test(this.hide.tel4 - 0)) {
            flag = true;
          }
        }
        if (this.hide.mail4.length) {
          if (!eReg.test(this.hide.mail4)) {
            flag = true;
          }
        }
        if (this.hide.tel5.length) {
          if (!pReg.test(this.hide.tel5 - 0)) {
            flag = true;
          }
        }
        if (this.hide.mail5.length) {
          if (!eReg.test(this.hide.mail5)) {
            flag = true;
          }
        }
        if (flag) {
          this.$message({
            message: "请确认输入的内容是否正确!",
            type: "warning"
          });
        } else {
          emailStr += this.hide.mail1 + ",";
          emailStr += this.hide.mail2 + ",";
          emailStr += this.hide.mail3 + ",";
          emailStr += this.hide.mail4 + ",";
          emailStr += this.hide.mail5;
          phoneStr += this.hide.tel1 + ",";
          phoneStr += this.hide.tel2 + ",";
          phoneStr += this.hide.tel3 + ",";
          phoneStr += this.hide.tel4 + ",";
          phoneStr += this.hide.tel5;
          remarkStr += this.hide.remarks1 + ",";
          remarkStr += this.hide.remarks2 + ",";
          remarkStr += this.hide.remarks3 + ",";
          remarkStr += this.hide.remarks4 + ",";
          remarkStr += this.hide.remarks5;
          const arr = [];
          arr.push({
            soId: this.$store.state.Soid,
            email: this.hide.mail1,
            phone: this.hide.tel1,
            remark: this.hide.remarks1
          });
          arr.push({
            soId: this.$store.state.Soid,
            email: this.hide.mail2,
            phone: this.hide.tel2,
            remark: this.hide.remarks2
          });
          arr.push({
            soId: this.$store.state.Soid,
            email: this.hide.mail3,
            phone: this.hide.tel3,
            remark: this.hide.remarks3
          });
          arr.push({
            soId: this.$store.state.Soid,
            email: this.hide.mail4,
            phone: this.hide.tel4,
            remark: this.hide.remarks4
          });

          arr.push({
            soId: this.$store.state.Soid,
            email: this.hide.mail5,
            phone: this.hide.tel5,
            remark: this.hide.remarks5
          });
          console.log(arr);
          //this.axios.get(this.$store.state.Url4 + 'warning/updWarningById_',
          this.axios
            .post(this.$store.state.Url4 + "/zhsd/warning/batchAddWarning", {
              warningList: arr
            })
            .then(data => {
              if (data.data.success) {
                this.$message({
                  message: data.data.message,
                  type: "success"
                });
                this.closeHander();
              } else {
                this.$message({
                  message: data.data.message,
                  type: "warning"
                });
              }
            })
            .catch(err => {
              console.log(err);
            });
        }
      }
    },
    // 编辑
    saveDialogitem(item) {
      this.yzType = item.yzType;
      this.yzMin = item.yzMin;
      this.yzMax = item.yzMax;
      this.id = item.eleId;
      this.dialogVisible1 = true;
    },
    saveDialog() {
      this.axios
        .get(this.$store.state.Url4 + "monitoringElements/updEleInfoByEleId", {
          params: {
            yzType: this.yzType,
            yzMax: this.yzMax,
            yzMin: this.yzMin,
            id: this.id
          }
        })
        .then(res => {
          console.log(res);
          this.getData(this.nowStcd);
        });
      // 发送请求
      this.dialogVisible1 = false;
    },
    // 关闭拟态框
    closeHander() {
      this.needHide = false;
    },
    // 打开拟态框
    editRecipient() {
      this.axios
        .get("http://47.110.245.84:9004/zhsd/warning/queryWarningByFilter")
        .then(res => {
          this.dialogVisible = true;
          if (res.data.data.length == 0) {
            this.recipientData = [];
            this.recipientData.push({
              email: "",
              phone: "",
              realName: "",
              remark: ""
            });
          } else {
            this.recipientData = res.data.data;
          }
        });
    },
    addRecipient() {
      this.recipientData.push({
        email: "",
        phone: "",
        realName: "",
        remark: ""
      });
    },
    saveRecipient() {
      const arr = [];
      this.recipientData.forEach((item, index) => {
        if (
          item.email.trim() != "" &&
          item.phone.trim() != "" &&
          item.realName.trim() != ""
        ) {
          arr.push(item);
        }
      });
      let datalist = {
        warningList:arr
      }
      console.log(datalist);
      console.log(datalist);
   $.ajax({
          headers: {
            token:  sessionStorage.getItem('token')
          },
          type: 'post',
          data: 
          JSON.stringify(datalist)
         ,
         contentType: "application/json;charset=UTF-8",
          url: "http://47.110.245.84:9004/zhsd/warning/batchAddWarning",
          success: data => {
                console.log(data)
          }
          });
      // this.axios.post("http://47.110.245.84:9004/zhsd/warning/batchAddWarning", {datalist} )
      //   .then(res => {
      //      this.dialogVisible = false;
      //     if (res.data.code == 200) {
      //       this.$message({
      //         message: "保存成功！",
      //         type: "success"
      //       });
      //     }
      //   });
       this.dialogVisible = false;
    },
    // 获取站点列表
    getStationData() {
      this.axios
        .get(
          this.$store.state.Url4 +
            "station/findStationAll?soId=" +
            this.$store.state.Soid
        )
        .then(data => {
          data = data.data.data;
          if (data.length === 0) {
            this.$message({
              message: "暂无数据",
              type: "warning"
            });
            this.getData(this.nowStcd);
            return false;
          }
          this.stationsItem = [];
          for (let i in data) {
            if (i - 0 === 0) {
              this.stationsItem.push({
                stnm: data[i].STNM,
                stcd: data[i].STCD,
                check: true
              });
              this.nowStcd = data[i].STCD;
              this.getData(data[i].STCD);
            } else {
              this.stationsItem.push({
                stnm: data[i].STNM,
                stcd: data[i].STCD,
                check: false
              });
            }
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    // 获取元素信息
    getData(stcd) {
      this.axios
        .get(
          this.$store.state.Url4 +
            "naturalFactors/queryMonitoringEleInfo?stcd=" +
            stcd
        )
        .then(data => {
          data = data.data.data;
          this.listData = data;
          console.log(this.listData);
          if (!this.listData) {
            return;
          }
          this.listData.forEach(item => {
            item.yzType = item.yzType + "";

            if (item.yzType == "1") {
              item.yzTypename = "区间范围外";
            } else if (item.yzType == "0") {
              item.yzTypename = "区间范围内";
            } else {
              item.yzTypename = "";
            }
          });
        })
        .catch(err => {
          console.log(err);
        });
    }
  },
  mounted() {
    this.getStationData();
  }
};
</script>

<style scoped="scoped">
.container {
  height: 100%;
  overflow: hidden;
}
.perLin {
  overflow: hidden;
  padding: 7px 0;
  height: 40px;
  line-height: 40px;
  font-size: 16px;
}
.perLin > div {
  float: left;
  width: 100%;
}
.box {
  height: 100%;
  width: 100%;
  overflow: hidden;
  position: relative;
}
.box > div {
  float: left;
  height: calc(100% + 1px);
}
.list_select {
  width: 300px;
  text-align: center;
  height: 100%;
}
.select_container {
  height: 100%;
}
.select_box > p {
  height: 50px;
  line-height: 50px;
  color: #08961f;
  font-weight: bold;
  border-bottom: 1px solid #00000055;
  font-size: 19px;
  cursor: pointer;
  text-align: left;
  margin-left: 33px;
}
.station_select {
  box-sizing: border-box;
  border-left: 5px solid #08961f;
  background: #f7f7f7;
  height: calc(100% - 100px - 51px - 34px);
}
.station_select p {
  height: 40px;
  line-height: 40px;
  cursor: pointer;
  text-align: left;
  box-sizing: border-box;
  padding-left: 25px;
}
.station_select p span {
  margin-left: 10px;
}
.station_act {
  color: #08961f;
}
.station_select span {
  font-size: 14px;
}

.dialog-footer {
  width: 160px;
  margin: 0 auto;
}
.message {
  width: calc(100% - 300px);
  height: 100%;
  overflow: hidden;
  box-sizing: border-box;
  padding: 14px 20px;
}
.header {
  text-align: right;
  /* margin-bottom: 20px; */
}
.list_container {
  height: calc(100% - 60px);
}
.list {
  height: 54px;
  line-height: 54px;
  overflow: hidden;
}
.list_title {
  text-align: center;
  color: #a9a9a9;
  font-weight: bold;
}
.list_box {
  height: calc(100% - 53px);
}
.list > div {
  padding: 0 15px;
  height: 54px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  float: left;
  box-sizing: border-box;
  border: 1px solid #dfe6ec;
  border-top: none;
  border-right: none;
}
.list_title > div {
  border-top: 1px solid #dfe6ec;
  border-right: none;
}
.list > div:last-child {
  border-right: 1px solid #dfe6ec;
}
.list > div:nth-child(1),
.list > div:nth-child(2),
.list > div:nth-child(3),
.list > div:nth-child(4),
.list > div:nth-child(5),
.list > div:nth-child(6) {
  width: calc((100% - 96px) / 6);
}
.list > div:nth-child(7) {
  width: 96px;
  text-align: center;
}

.hide {
  position: absolute;
  left: 0;
  top: 0;
  z-index: 233;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
}
.hide_container {
  position: relative;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.hide_box {
  padding: 20px 20px;
  box-sizing: border-box;
  width: 800px;
  background: #ffffff;
  z-index: 456;
}
.hide_module {
  overflow: hidden;
  padding: 5px 0;
  height: 40px;
  line-height: 40px;
}
.hide_module > div {
  position: relative;
  float: left;
  width: 33.33%;
  text-align: right;
}
.hide_module > div span {
  margin-right: 5px;
}
.hide_module > div .el-input {
  width: calc(100% - 71px);
}
.hide_btns {
  text-align: center;
  margin-top: 7px;
}
.query_btns {
  display: inline-block;
  font-size: 16px;
  padding: 4px 15px;
  border-radius: 5px;
  margin-right: 10px;
  overflow: hidden;
  cursor: pointer;
  line-height: 12px;
}
.header > .query_btns {
  padding: 4px 7px;
  position: absolute;
  left: 236px;
  top: 14px;
}
.list .query_btns {
  margin-top: 7px;
  margin-right: 0;
}
.info_btn {
  background-color: rgba(184, 134, 11, 0.2);
  border: 1px solid rgba(184, 134, 11, 0.667);
  color: #b8860b;
  margin-left: 10px;
}
.edit_btn {
  background-color: rgba(29, 168, 56, 0.2);
  border: 1px solid rgba(29, 168, 56, 0.667);
  color: #1da838;
}
.close_btn {
  background-color: rgba(220, 20, 60, 0.2);
  border: 1px solid rgba(220, 20, 60, 0.667);
  color: #dc143c;
}
.save_btn {
  background-color: rgba(19, 152, 226, 0.2);
  border: 1px solid rgba(19, 152, 226, 0.667);
  color: #1398e2;
}
</style>
<style>
.__rail-is-vertical {
  right: 0 !important;
}
.site_edit_input .el-input__inner {
  height: 54px;
  position: relative;
  top: -1px;
  border: none;
  border-radius: 0;
}
.index_content > .list > .site_edit_select {
  padding: 0;
}
.site_edit_input .el-autocomplete {
  width: 100%;
}
.el-input-number__decrease,
.el-input-number__increase {
  height: 38px;
}
</style>



// WEBPACK FOOTER //
// src/components/warningIssued/warningIssued.vue